export default "__VITE_ASSET__DEoegGYw__"